import type { FetchMeQuery } from '@salescore/client-api'
import { UserAvatar } from '@salescore/client-common'
import { ellipsisFilter } from '@salescore/frontend-common'
import { Link } from '@tanstack/react-router'
import type { ReactElement } from 'react'

export const SiderUserV2 = ({ myUser }: { myUser: FetchMeQuery['myUser'] }): ReactElement => (
  <Link to="/o/$organizationId/v2/settings/me" params={{ organizationId: myUser.organization.id }}>
    <div className="flex w-full cursor-pointer items-center px-4 py-3 align-middle hover:bg-slate-50 hover:opacity-90">
      <UserAvatar name={myUser.name} imageUrl={myUser.imageUrl ?? ''} />
      <div style={{ width: 140 }} className="flex items-center justify-between align-middle">
        <div className="ml-2 text-sm" style={{ wordBreak: 'break-all' }}>
          {ellipsisFilter(myUser.name, 13)}
          <br />
          <span className="text-xs text-gray-500">{ellipsisFilter(myUser.identity.email, 20)}</span>
        </div>
      </div>
    </div>
  </Link>
)
